import { useParams } from "@tanstack/react-router";

import HStack from "@/components/Layout/HStack";
import VStack from "@/components/Layout/VStack";
import { Text } from "@/components/Typography/Text";
import { useGetGroupId } from "@/routes/_staff/ids/-api";

export default function GroupIdHeader() {
  const proxyUserId = useParams({
    from: "/_staff/ids/group-id/$id/_$id",
  }).id;
  const { data } = useGetGroupId(proxyUserId);

  return (
    <HStack className="gap-4">
      <VStack>
        <Text variant="h2">{data.loginId}</Text>
        <span className="text-sm font-semibold text-muted-foreground">
          {data.name}
        </span>
      </VStack>
    </HStack>
  );
}
